export default __webpack_public_path__ + "static/media/wwjbl.ac1aac7d.png";